import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["style", "className"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import PropTypes from 'prop-types';
import { memo, useMemo } from 'react';
import { COOKIE_BANNER_SAFE_AREA_CLASSNAME } from "./constants";
import { useCookieBannerHeight } from "./cookie-safe-area-provider";
import { jsx as _jsx } from "react/jsx-runtime";
export var CookieSafeAreaSpacer = function CookieSafeAreaSpacer(_ref) {
  var style = _ref.style,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var cookieBannerHeight = useCookieBannerHeight();
  var computed = useMemo(function () {
    return {
      className: className ? "".concat(className, " ").concat(COOKIE_BANNER_SAFE_AREA_CLASSNAME) : COOKIE_BANNER_SAFE_AREA_CLASSNAME,
      style: _objectSpread(_objectSpread({}, style), {}, {
        height: cookieBannerHeight
      })
    };
  }, [style, className, cookieBannerHeight]);
  if (typeof cookieBannerHeight === 'undefined') {
    return null;
  }
  return /*#__PURE__*/_jsx("div", _objectSpread({
    "data-testid": COOKIE_BANNER_SAFE_AREA_CLASSNAME,
    className: computed.className,
    style: computed.style
  }, props));
};
CookieSafeAreaSpacer.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string
};
CookieSafeAreaSpacer.defaultProps = {
  style: undefined,
  className: undefined
};
export default /*#__PURE__*/memo(CookieSafeAreaSpacer);